import React from 'react';

import { graphql } from 'gatsby';

import { extractTextMarking, PageHeadline } from '@mewa/ui';

import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';

export const Heading2Fragment = graphql`
  fragment Heading2Fragment on STRAPI__COMPONENT_SHARED_HEADING_2 {
    title: Title
    strapi_component
  }
`;

export const componentName = 'shared.heading-2';

export type Heading2Data = {
  title: string;
  strapi_component: typeof componentName;
};

export type Heading2Preview = {
  strapi_component: typeof componentName;
  Title: string;
};

export const isHeading2 = (
  component: PossibleContentSections,
): component is Heading2Data => {
  return component.strapi_component === componentName;
};

export const StrapiHeading2 = ({ title }: ComponentProps<Heading2Data>) => {
  const markedHeadline = extractTextMarking(title);

  return (
    <PageHeadline
      component="h2"
      title={
        <>
          {markedHeadline.beforeMarking}
          <strong>{markedHeadline.marking}</strong>
          {markedHeadline.afterMarking}
        </>
      }
    />
  );
};

export const config = {
  isComponent: isHeading2,
  Component: StrapiHeading2,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  componentName,
  populationParams: {},
  mapProperties: (heading2): Heading2Data | null =>
    heading2.strapi_component === componentName
      ? { strapi_component: heading2.strapi_component, title: heading2.Title }
      : null,
};
